import axios from 'axios';

const apiClient = axios.create({
  // Use environment variables for flexibility; fallback to the production URL
  baseURL: process.env.REACT_APP_API_BASE_URL || 'https://trustserv.org',
  timeout: 10000,
  headers: { 
    'Content-Type': 'application/json' 
  }
});

// Add a response interceptor for global error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Centrally log errors or handle specific status codes
    if (error.response) {
      if (error.response.status === 401) {
        console.error('Unauthorized! Redirecting to login...');
        // Optional: window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;